import { render, staticRenderFns } from "./ImagesPreview.vue?vue&type=template&id=4bc99507&scoped=true&"
import script from "./ImagesPreview.vue?vue&type=script&lang=js&"
export * from "./ImagesPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagesPreview.vue?vue&type=style&index=0&id=4bc99507&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc99507",
  null
  
)

export default component.exports